module.exports = __webpack_public_path__ + "img/border.48b14c27.png";